import { permissionDependency, PERMISSIONS } from 'utils/constants';

export const updateWorkOrdersPermissionsState = (
  data,
  filteredPermissionsList,
  key,
) => {
  let clonedData = data;
  let selected = filteredPermissionsList?.[key]?.find(
    (item) => item?.title === PERMISSIONS.CAN_VIEW_WORK_ORDERS,
  );

  const isEnable = data?.includes(selected?.id);
  if (!isEnable) {
    selected = filteredPermissionsList?.[key]?.find(
      (item) => item?.title === PERMISSIONS.CAN_ONLY_VIEW_OWN_WORK_ORDERS,
    );

    clonedData = clonedData?.filter((id) => id != selected?.id);

    selected = filteredPermissionsList?.[key]?.find(
      (item) =>
        item?.title ===
        PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS_AT_OWN_LOCATIONS,
    );

    clonedData = clonedData?.filter((id) => id != selected?.id);

    selected = filteredPermissionsList?.[key]?.find(
      (item) => item?.title === PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS,
    );

    clonedData = clonedData?.filter((id) => id != selected?.id);
  }

  const CanOnlyViewOwn = filteredPermissionsList?.[key]?.find(
    (item) => item?.title === PERMISSIONS.CAN_ONLY_VIEW_OWN_WORK_ORDERS,
  );

  const CanViewOwnAndOthers = filteredPermissionsList?.[key]?.find(
    (item) =>
      item?.title === PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS_AT_OWN_LOCATIONS,
  );

  const CanViewAll = filteredPermissionsList?.[key]?.find(
    (item) => item?.title === PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS,
  );

  const isNotExists =
    !data?.includes(CanOnlyViewOwn?.id) &&
    !data?.includes(CanViewOwnAndOthers?.id) &&
    !data?.includes(CanViewAll?.id);

  if (isNotExists || !isEnable) {
    const CanManageTasks = filteredPermissionsList?.[key]?.find(
      (item) => item?.title === PERMISSIONS.CAN_MANAGE_WORK_ORDERS,
    );

    clonedData = clonedData?.filter((id) => id != CanManageTasks?.id);
  }

  return clonedData;
};

export const updateViewWorkOrdersPermissions = (
  data,
  permission,
  isChecked,
  permissionsList,
  key,
) => {
  let clonedData = data;

  const canViewAll = permissionsList?.[key]?.find(
    (item) => item?.title === PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS,
  );

  const CanViewOwnAndOtherLocations = permissionsList?.[key]?.find(
    (item) =>
      item?.title === PERMISSIONS.CAN_VIEW_OTHERS_WORK_ORDERS_AT_OWN_LOCATIONS,
  );

  const CanViewOwn = permissionsList?.[key]?.find(
    (item) => item?.title === PERMISSIONS.CAN_ONLY_VIEW_OWN_WORK_ORDERS,
  );

  if (permission === canViewAll?.id && isChecked) {
    clonedData = clonedData?.filter(
      (id) => id != CanViewOwnAndOtherLocations?.id && id != CanViewOwn?.id,
    );
  }

  if (permission === CanViewOwnAndOtherLocations?.id && isChecked) {
    clonedData = clonedData?.filter(
      (id) => id != canViewAll?.id && id != CanViewOwn?.id,
    );
  }

  if (permission === CanViewOwn?.id && isChecked) {
    clonedData = clonedData?.filter(
      (id) => id != canViewAll?.id && id != CanViewOwnAndOtherLocations?.id,
    );
  }

  return clonedData;
};

export const updatePermissionsState = (
  data,
  group,
  filteredPermissionsList,
) => {
  let clonedData = data;
  Object.entries(permissionDependency[group]).forEach(
    ([parentPermission, dependentPermissions]) => {
      const dependencies = dependentPermissions as string[];

      // Find the parent permission ID

      const parentPermissionObj: any = Object.values(
        filteredPermissionsList || {},
      )
        .flat()
        .find((item: any) => item?.title === parentPermission);

      if (!parentPermissionObj) return;

      // Check if parent permission is enabled
      const isParentEnabled = data?.includes(parentPermissionObj?.id);

      // If parent permission is not enabled, remove all dependent permissions
      if (!isParentEnabled) {
        dependencies.forEach((permission) => {
          const dependentPermissionObj: any = Object.values(
            filteredPermissionsList || {},
          )
            .flat()
            .find((item: any) => item?.title === permission);

          if (dependentPermissionObj) {
            clonedData = clonedData?.filter(
              (id) => id != dependentPermissionObj?.id,
            );
          }
        });
      }
    },
  );

  return clonedData;
};
